'use strict';
var unitas = unitas || {};
const navItems = document.querySelectorAll('.js-page-travel-scroll-nav-item');
const fixedBar = document.querySelector('#js-page-travel-fixed-bar');
const getOfferBox = document.querySelector('#js-get-offer-box');
unitas.pagetravel = unitas.pagetravel || function () {
	function init() {
        if(navItems.length > 0) {
            for (let i = 0; i < navItems.length; i++) {
                let currentItem = navItems[i];
                let currentItemIdLinkId = currentItem.getAttribute('href');
                const scrollElementOnPage = document.querySelector(currentItemIdLinkId);
                if(!scrollElementOnPage) {
                    currentItem.style.display = 'none';
                }
            }
        }
        if(window.innerWidth > 992) {
            if(fixedBar) {
                let getOfferBoxRect = getOfferBox.getBoundingClientRect();

                document.addEventListener('scroll', function() {
                    getOfferBoxRect = getOfferBox.getBoundingClientRect();
                    if(getOfferBoxRect.y + (getOfferBoxRect.height / 2) < 0) {
                        fixedBar.classList.add('page-travel-fixed-bar--visible');
                    } else {
                        fixedBar.classList.remove('page-travel-fixed-bar--visible');
                    }
                });
            }
        }
	}
	return {
		init : init
	};
}();